import useConstructionNewHook from "../../../hooks/useConstructionNewHook";

const useSaveModifiedConstructionHook = (): ((
  constructionId: string | undefined,
  calculationId: string,
  timeStamp: string,
) => Promise<void>) => {
  const {saveModified} = useConstructionNewHook();

  const save = async (
    id: string | undefined,
    calculationId: string,
    timeStamp: string,
  ): Promise<void> => {
    if (id === undefined) {
      throw new Error("Missing id");
    }

    await saveModified(id, calculationId, timeStamp);
  };

  return save;
};

export default useSaveModifiedConstructionHook;
